import React from 'react';
import moment from 'moment';
import { Box, Button, Card, CardActionArea, Stack, Typography } from '@material-ui/core';

import { getStatusLabel } from '../../constants/pedidos';

const URGENT_BG = '#ffe2da';
const URGENT_ACCENT = '#d84315';

export const PedidoCard = ({ item, onClick, action, accentColor }) => {
  if (!item) return null;
  const isUrgente = item.prioridade === 'urgente';
  const fullName = `${item.first_name ?? ''} ${item.last_name ?? ''}`.trim() || '—';
  const transTypeLabel = item.trans_type === 'delivery' ? 'Entrega' : 'Retirada';
  const leftAccent = isUrgente ? URGENT_ACCENT : accentColor;

  return (
    <Card
      sx={{
        width: '100%',
        borderRadius: 1,
        border: '1px solid',
        borderColor: isUrgente ? URGENT_ACCENT : 'grey.200',
        borderLeft: leftAccent ? `3px solid ${leftAccent}` : undefined,
        boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
        overflow: 'hidden',
      }}
    >
      <CardActionArea
        onClick={onClick}
        sx={{
          bgcolor: isUrgente ? URGENT_BG : 'background.paper',
          p: 0.875,
          '&:hover': { bgcolor: isUrgente ? URGENT_BG : 'grey.50' },
        }}
      >
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ minWidth: 0 }}>
            <Typography
              sx={{ fontWeight: 700, fontSize: '0.78rem', color: '#1a1a2e', lineHeight: 1.2 }}
              noWrap
            >
              #{item.number}
            </Typography>
            <Typography sx={{ fontSize: 10, color: 'text.secondary', flexShrink: 0, ml: 0.5 }}>
              {moment(item.date_created).format('DD/MM HH:mm')}
            </Typography>
          </Stack>

          <Typography
            noWrap
            sx={{
              fontWeight: 600,
              fontSize: '0.72rem',
              color: '#333',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              lineHeight: 1.25,
            }}
            title={fullName}
          >
            {fullName}
          </Typography>

          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ minWidth: 0, gap: 0.5 }}>
            <Typography
              sx={{
                fontSize: 9,
                color: 'text.secondary',
                textTransform: 'uppercase',
                letterSpacing: 0.3,
                lineHeight: 1.2,
              }}
              noWrap
            >
              {transTypeLabel}
            </Typography>
            <Typography
              sx={{
                fontSize: 9,
                color: leftAccent ?? 'text.secondary',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: 0.3,
                lineHeight: 1.2,
                textAlign: 'right',
              }}
              noWrap
              title={getStatusLabel(item.status_id)}
            >
              {getStatusLabel(item.status_id)}
            </Typography>
          </Stack>
        </Stack>
      </CardActionArea>

      {action && (
        <Box sx={{ px: 0.75, pb: 0.75 }}>
          <Button
            fullWidth
            variant="contained"
            startIcon={action.icon}
            onClick={action.onClick}
            disabled={action.disabled}
            sx={{
              bgcolor: accentColor ?? '#1a1a2e',
              color: '#fff',
              '&:hover': { bgcolor: accentColor ?? '#16213e', filter: 'brightness(0.92)' },
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '0.7rem',
              minHeight: 28,
              py: 0.5,
              borderRadius: 0.75,
              '& .MuiButton-startIcon': { mr: 0.5, '& > *:first-of-type': { fontSize: 12 } },
            }}
          >
            {action.label}
          </Button>
        </Box>
      )}
    </Card>
  );
};

export default PedidoCard;
